import React, { useEffect, useState } from 'react';
import { IAuditLogItemResponse } from 'models/auditLog';
import { Typography } from '@mui/material';
import { DetailsTemplate, EDetailsPageTypes } from 'components/templates/DetailsTemplate';
import Grid from '@mui/material/Grid';
import { useTranslations } from 'hooks/useTranslations';
import { ERouteLinks } from 'models/route';
import { useNavigate } from 'react-router-dom';
import { IGlobalSearchAuditLog } from 'models/globalSearch';

interface IGlobalSearchEventDetails {
  auditLog: IAuditLogItemResponse;
}

const GlobalSearchEventDetails = ({ auditLog }: IGlobalSearchEventDetails) => {
  const { t } = useTranslations();
  const [globalSearch, setGlobalSearch] = useState<IGlobalSearchAuditLog | null>();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (auditLog?.postObjectValue) {
        const postObjectValue = auditLog?.postObjectValue as any;
        setGlobalSearch(postObjectValue);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditLog]);

  return (
    <Grid>
      {globalSearch && (
        <DetailsTemplate
          pageType={EDetailsPageTypes.auditLogView}
          title={globalSearch.phrase}
          redirectToView={() =>
            navigate(`${ERouteLinks.DashboardSearchResultsPage}?query=${globalSearch.phrase}`)
          }
        >
          <Grid size={{ xs: 12, lg: 3 }}>
            <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
              {t('general.search.label')}
            </Typography>
            <Typography variant="body2">{globalSearch.auditLogSearchType}</Typography>
          </Grid>
          <Grid size={{ xs: 12, lg: 3 }}>
            <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
              {t(`dashboard.search.${globalSearch.auditLogSearchType.toLowerCase()}.label`)}
            </Typography>
            <Typography variant="body2">{globalSearch.phrase}</Typography>
          </Grid>
        </DetailsTemplate>
      )}
    </Grid>
  );
};

export default GlobalSearchEventDetails;
